<template>
  <basic-container>
    <div class="cancel-user-container">
      <!-- 搜索区域 -->
      <div class="search-area">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline" size="small">

          <!-- 用户账户  -->
          <el-form-item>
            <el-input v-model="searchForm.mobile" placeholder="用户账户" clearable></el-input>
          </el-form-item>

          <!-- 全部状态 -->
          <el-form-item>
            <el-select v-model="searchForm.cancelStatus" placeholder="全部状态" clearable>
              <el-option label="注销冻结" value="1"></el-option>
              <el-option label="注销" value="2"></el-option>
            </el-select>
          </el-form-item>

          <!-- 全部注册方式 -->
          <el-form-item>
            <el-select v-model="searchForm.regType" placeholder="全部注册方式" clearable>
              <el-option v-for="item in regTypeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
            </el-select>
          </el-form-item>

          <el-form-item>
            <DynamicOption v-model="searchForm.appid" :placeholder="'全部来源渠道'" :singleSelect="true"
              :params="searchOptions" />
          </el-form-item>

          <!-- 最后登陆产品 -->
          <el-form-item>
            <el-select v-model="searchForm.pid" placeholder="最后登陆产品" clearable>
              <el-option v-for="item in clientTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-date-picker v-model="time" type="daterange" range-separator="至"
              start-placeholder="请选择注册时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
          </el-form-item>

          <el-form-item>
            <el-button type="success" @click="handleExport">导出为Excel</el-button>
          </el-form-item>

        </el-form>

      </div>

      <!-- 表格区域 -->
      <!-- <el-table :data="tableData" border style="width: 100%" v-loading="loading"> -->
      <el-table :cell-style="{ 'text-align': 'center' }" :header-cell-style="{ 'text-align': 'center' }"
      :max-height="tableHeight" v-loading="listLoading" element-loading-text="加载中" border :data="tableData"
      :row-style="{ height: '30px' }">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="mobile" label="用户账号" width="120"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.cancelState === 1 ? 'warning' : 'danger'">
              {{ scope.row.cancelState === 1 ? '注销冻结' : '已注销' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column  label="注册方式" width="120">
          <template slot-scope="scope">
            {{ getRegTypeDescByRegType(scope.row.regType) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="180"></el-table-column>
        <el-table-column prop="source" label="来源渠道" width="300" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getSourceChannel(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="最后登陆产品" width="150"></el-table-column>
        <el-table-column prop="deviceInfo" label="最后设备号ID" width="150" show-overflow-tooltip></el-table-column>


        <el-table-column prop="lastTime" label="最后账号登录时间" width="180"></el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="handleUnbind(scope.row)"
              v-if="scope.row.cancelState === 1">解除注销</el-button>
            <el-button size="mini" type="danger" @click="handleConfirm(scope.row)"
              v-if="scope.row.cancelState === 1">注销确认</el-button>
          </template>
        </el-table-column>
      </el-table>


     <!-- 分页 -->
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="page.current" :page-sizes="page.pageSizeArr" :page-size="page.size"
        :layout="paginationLayout" :total="page.total">
      </el-pagination>
    </div>
    </div>
  </basic-container>
</template>

<script>
// import {  removeCancel, confirmCancel ,getClientType} from '@/api/user/cancelUser'
import {getCancelUserList,removeCancel, confirmCancel ,getClientType,getRegType,exportCancelUserList} from '@/api/user/cancelUser'
import DynamicOption from "@/components/DynamicOption/index.vue";
export default {
  name: 'CancelUserManage',
  components: {
    DynamicOption,
  },
  data() {

    return {
      // 搜索表单
      searchForm: {
        status: '',
        mobile: '',
        regType: '',
        cancelStatus: '',
        appid: '',
        pid: '',
      },
      time: [],
      // 客户端类型
      clientTypes: [],
      // 表格数据
      tableData: [],
      // 注册方式
      regTypeList: [],
      // 加载状态
      loading: false,
      // 分页信息
      page: {
        current: 1,
        size: 10,
        total: 0,
        pageSizeArr: [10, 20, 30, 40, 50],
      }
      
    }
  },
  created() {
    this.getList()
    this.fetchClientTypes()
    this.fetchRegType()
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.loading = true
      try {
        // 构造请求参数
        const params = {
          ...this.searchForm,
          current: this.page.current,
          size: this.page.size
        }
        if (this.time && this.time.length === 2) {
          params.startTime = this.time[0]
          params.endTime = this.time[1]
        }

        // 模拟数据，实际项目中替换为API调用
        const res = await getCancelUserList(params)
        this.tableData = res.data.data.records
        this.page.total = res.data.data.total
        this.page.current = res.data.data.current
        this.page.size = res.data.data.size
      } catch (error) {
        console.error('获取列表失败：', error)
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },
    /** 系统字典获取注册方式描述 */
    async fetchRegType() {
      const { data } = await getRegType();
      console.log("获取注册方式描述", data);
      this.regTypeList = data.data
    },

    // 搜索
    handleSearch() {
      this.page.current = 1
      this.getList()
    },

    // 导出Excel
    handleExport() {
      this.$message.success('开始导出Excel')
      // 实现导出逻辑
      const params = {
          ...this.searchForm,
          current: this.page.current,
          size: this.page.size
        }
        if (this.time && this.time.length === 2) {
          params.startTime = this.time[0]
          params.endTime = this.time[1]
        }
      exportCancelUserList(params)
    },

    // 解除注销
    async handleUnbind(row) {
      try {
        await this.$confirm('确定要解除该用户的注销？', '提示', {
          type: 'warning'
        })
        await removeCancel(row.id)
        this.$message.success('操作成功')
        this.getList()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('操作失败')
        }
      }
    },

    // 注销确认
    async handleConfirm(row) {
      try {
        await this.$confirm('注销后会永久删除账号信息、登录信息、订单信息、设备信息、投屏信息等！', '提示', {
          type: 'warning'
        })
        await confirmCancel(row.id)
        this.$message.success('操作成功')
        this.getList()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('注销失败')
        }
      }
    },

    /** 获取客户端类型 */
    async fetchClientTypes() {
      const { data } = await getClientType();
      console.log("获取客户端类型", data);
      this.clientTypes = data.data[0].children.map((item) => {
        return {
          label: item.dictValue,
          value: item.dictKey,
        };
      });
    },
    /** 获取注册方式描述 */
    getRegTypeDescByRegType(regType) {
      const item = this.regTypeList.find(item => item.dictKey === String(regType));
      return item ? item.dictValue : regType;
    },

    // 获取来源渠道，包括是否发送端，接收端，哪里的sdk/app
    getSourceChannel(row) {
      let channel = `[${row.appid}]${row.channelName}/`;
      if (row.terminalType === 1) {
        channel += '发送端/';
      } else {
        channel += '接收端/';
      }

      if (row.vipType === 0) {
        channel += '公版sdk';
      } else if (row.vipType === 1) {
        channel += '公版app';
      } else if (row.vipType === 2) {
        channel += '定制sdk';
      } else {
        channel += '定制app';
      }
      return channel;
    },
    

    // 分页大小改变
    handleSizeChange(val) {
      this.page.size = val
      this.getList()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.cancel-user-container {
  .ellipsis-text {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .search-area {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
}
</style>